import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { GETTING_STUDENTS, GET_STUDENTS, STUDENTS_ERROR, UPDATED_STUDENT, UPDATING_STUDENT } from "../types"

// export const createApplication = (applicationPayload) => async (dispatch) => {    
//     try{
//         const headers = authHeader()

//         dispatch({
//             type: CREATING_APPLICATION,
//             payload: true
//         })

//         const response = await axios.post(`${baseUrl}/applications`, applicationPayload, { headers })
        
//         dispatch({
//             type: CREATE_APPLICATION,
//             payload: response.data.data
//         })
        
//     }
//     catch(error){
//         dispatch({
//             type: APPLICATIONS_ERROR,
//             error
//         })
//     }
// }

export const updateStudent = (studentId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_STUDENT,
            payload: true
        })
        const response = await axios.patch(`${baseUrl}/students/${studentId}`, payload, { headers })
        
        dispatch({
            type: UPDATED_STUDENT,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: STUDENTS_ERROR,
            error
        })
    }
}

export const fetchStudents = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/students`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_STUDENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_STUDENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: STUDENTS_ERROR,
            error
        })
    }
}

// export const clearCreatedApplication = () => async (dispatch) => { 
//     dispatch({
//         type: CREATE_APPLICATION,
//         payload: null
//     })
// }

export const clearUpdatedStudent = () => async (dispatch) => { 
    dispatch({
        type: UPDATED_STUDENT,
        payload: null
    })
}